import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CustomDashboardsService} from "app/modules/my-limegear/services/my-limegear.service";
import {PipelineLockStatusService} from "app/modules/pipeline/services/pipeline-lock-status.service";
import {NoDataActionType} from "app/modules/shared/interfaces/no-data";
import {ICardData} from "app/modules/pipeline/interfaces/pipeline-data";

@Component({
    selector: 'pipeline-lock-status-by-milestone-lgc',
    templateUrl: './pipeline-lock-status-by-milestone-lgc.component.html',
    styleUrls: ['./pipeline-lock-status-by-milestone-lgc.component.scss']
})
export class PipelineLockStatusByMilestoneLgcComponent implements OnInit, AfterViewInit {

    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private _cardService: PipelineLockStatusService,
    ) {
    }

    action: NoDataActionType;
    card: ICardData;

    ngOnInit() {
        this.action = NoDataActionType.pageStart;
        this.card = {
            cardId: 'insights_lockStatusByMilestone',
            title: 'Lock Status by Milestone',
            isChartCard: true,
            urlSegment: 'insights_lockStatusByMilestone',
            drilldownUrl: '/reporting/pipeline/',
        };
        this._cardService.initializeCards(
            this.card,
            NoDataActionType.pageStart);
    }

    ngAfterViewInit() {
        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            let params = this._cardService.setAndGetParams(
                changes.hierarchyfilters,
                changes.displayOptions,
            );

            this._cardService.getPipelineLockStatusByMilestone(params).subscribe(
                (data) => {
                    let processedSeriesData = this._cardService.setStackChartData(
                        data,
                        'clientMilestoneName',
                        'lockStatus',
                        'bar'
                    );
                    this._cardService.updateChartData(
                        this.card, 
                        processedSeriesData, 
                        data.length > 0, 
                        true, 
                        '',
                        changes.action);
                },
                (err) => {
                    console.log('Error: ', err);
                    this._cardService.updateChartData(this.card, [], false, true, '', NoDataActionType.error);
                }
            );   
        });
    }
}
